/* global $, document */
// Third party
import React from 'react';
import {connect} from 'react-redux'

import 'jquery';
import 'bootstrapcss';
import './myStyle.css';
import $ from 'jquery';
// React-Bootstrap
import {
    Navbar, Nav, NavDropdown, NavItem, MenuItem, Checkbox, Radio, Modal,
    Grid, Row, Col, Button, Panel
} from 'react-bootstrap';
//import ReactGridLayout from 'react-grid-layout';
// The import approach wasn't working when trying to use the width provider so
// I used the "require" syntax per their basic example.
var WidthProvider = require('react-grid-layout').WidthProvider;
var ReactGridLayout = require('react-grid-layout');
ReactGridLayout = WidthProvider(ReactGridLayout);
// My "compoments" defined in separate files
import * as smallExNet from '../netSamples/ExNetwithLoops1B.json';
import * as medExNet from '../netSamples/KShortTest2Net.json';
import * as multiExNet from '../netSamples/MultiLayer2.json';

import ComputeServeDialog from './ComputeServeDialog';
import LoadNetDialog from './io/LoadNetDialog';
import ExportNetDialog from './io/ExportNetDialog';
import NodeAddDialog from './netDraw/NodeAddDialog';
import NodeEditDialog from './netDraw/NodeEditDialog';
import LinkAddDialog from './netDraw/LinkAddDialog';
import LinkEditDialog from './netDraw/LinkEditDialog';
import IPAddressDialog from './netManip/IPAddressDialog';
import PortNumberDialog from './netManip/PortNumberDialog';
import DistanceWeightsDialog from './netManip/DistanceWeightsDialog';
import RandomCapsDialog from './netManip/RandomCapsDialog';
import {netValidate} from './../validation/netValid';
import {pathCollectionValidate} from './../validation/pathValid';
import {Wrapper, NetDrawPanel, NetInfoPanel, HelpPanel, PathInfoPanel} from './AppPanels';
import MinSpanTreeDialog from './pathComp/MinSpanTreeDialog';
import ShortestPathDialog from './pathComp/ShortestPathDialog';
import WidestPathDialog from './pathComp/WidestPathDialog';
import PathLoadDialog from './io/LoadPathDialog';
import LoadDemandDialog from './io/LoadDemandsDialog';
import KShortestPathsDialog from './pathComp/KShortestPathsDialog';

export var App = React.createClass({
    getInitialState() {
        return {
            layout: []
        }
    },
    exampleNetLoad: function (ekey) {
        switch (ekey) {
            case 'loadSmNet':
                this.props.netLoad(netValidate(JSON.stringify(smallExNet)).netObj);
                return;
            case 'loadMedNet':
                this.props.netLoad(netValidate(JSON.stringify(medExNet)).netObj);
                return;
            case 'loadMultiNet':
                this.props.netLoad(netValidate(JSON.stringify(multiExNet)).netObj)
                return;
            default:
                this.props.netLoad(netValidate(JSON.stringify(smallExNet)).netObj);
        }

    },

    // Save the state of ReactGridLayout after drags and resizing events.
    layoutChangeHandler(currLayout) {
        this.props.netDrawResize();
        this.setState(Object.assign({}, this.state, {
            layout: currLayout
        }));
    },

    componentWillMount: function() {
        document.addEventListener("keydown", this.myKeyPress);
    },

    myKeyPress(e) {
        const DEL_KEY = 46;
        // If we are in edit mode delete selected nodes and links
        if (e.which === DEL_KEY && this.props.netVisInteract.mouseMode === 'edit') {
            let newNet, newDemands, newNetVis;
            [newNet, newDemands, newNetVis] = deleteSelectedNodesLinks(this.props.net,
                this.props.demands, this.props.netVisInteract);
            this.props.nodeLinkDelete(newNet, newDemands, newNetVis);
        }
    },

    openFile() {
        $("#fileInput").click();
    },

    openPathFile() {
        $("#pathFileInput").click();
    },

    netfileLoad() {
        //console.log("Someone selected a file...");
        // Good explanation of file inputs: https://developer.mozilla.org/en-US/docs/Using_files_from_web_applications
        var file = $('#fileInput').get(0).files[0];
        // console.log(file.name, file.type, file.size);
        var reader = new FileReader();
        var that = this;
        reader.onload = function () {
            //console.log(reader.result);
            let result = netValidate(reader.result);
            if (!result.errors) {
                // console.log(result.netObj);
                that.props.netLoad(result.netObj);
            } else {
                alert("Problem loading network: " + JSON.stringify(result.errors));
            }
        };
        reader.readAsText(file);
        file = $('#fileInput').get(0).value = null;
    },

    pathfileLoad() {
        //console.log("Someone selected a file...");
        // Good explanation of file inputs: https://developer.mozilla.org/en-US/docs/Using_files_from_web_applications
        var file = $('#pathFileInput').get(0).files[0];
        // console.log(file.name, file.type, file.size);
        var reader = new FileReader();
        var that = this;
        reader.onload = function () {
            //console.log(reader.result);
            let result = pathCollectionValidate(reader.result);
            if (!result.errors) {
                // console.log(result.pathObj);
                that.props.pathCollectionAdd(result.pathObj);
            } else {
                alert("Problem loading path: " + JSON.stringify(result.errors));
            }
        };
        reader.readAsText(file);
        file = $('#pathFileInput').get(0).value = null;
    },

    helpSelect() {
        this.props.dispatchHelp(true);
    },

    netInfoSelect() {
        this.props.dispatchNetInfo(true);
    },

    render: function () {
        let gridItems = [<Wrapper key={'drawPanel'} _grid={{i:'drawPanel', x: 0, y: 0, w: 5, h: 8, minW: 4}}>
            <NetDrawPanel net={this.props.net}/>
        </Wrapper>];
        if (this.props.showNetInfo) {
            gridItems.push(<Wrapper key={'infoPanel'} _grid={{i: 'infoPanel', x: 6, y: 0, w: 5, h: 8}}>
                <NetInfoPanel net={this.props.net} mode={this.props.netVisInteract.mouseMode}
                              demands={this.props.demands}
                              nameDescChange={this.props.nameDescChange}
                              closeFunc={this.props.dispatchNetInfo.bind(this, false)}/></Wrapper>);
        }
        if (this.props.showPathInfo) {
            gridItems.push(<Wrapper key={'pathPanel'} _grid={{i: 'pathPanel', x:6, y:0, w:5, h:8}}>
                <PathInfoPanel closeFunc={this.props.dispatchPathInfo.bind(this, false)}/></Wrapper>)

        }
        if (this.props.showHelp) {
            // console.log("You want help");
            gridItems.push(<Wrapper key={'helpPanel'} _grid={{i: 'helpPanel', x:6, y:0, w:5, h:8}}>
                <HelpPanel closeFunc={this.props.dispatchHelp.bind(this, false)}/></Wrapper>)
        }

        return (
            <div onKeyDown={this.myKeyPress} onKeyUp={this.myKeyPress} onKeyPress={this.myKeyPress}>
                <Navbar staticTop={true}>
                    <Navbar.Header>
                        <Navbar.Brand>
                            <a href="#"><img src={require("./../sideLogo.png")} alt="Grotto Networking" /></a>
                        </Navbar.Brand>
                        <Navbar.Toggle />
                    </Navbar.Header>
                    <Navbar.Collapse>
                        <Nav>
                            <NavDropdown eventKey={1} title="Net"
                                         id="Net-dropdown">
                                <MenuItem eventKey={1.1} onSelect={this.props.dispatchNetInfo.bind(this,true)}>Info</MenuItem>
                                <MenuItem divider/>
                                <MenuItem eventKey={1.2} onSelect={this.openFile}>Open Net
                                    File</MenuItem>
                                <NavDropdown eventKey={"loadEx"} title="Example Networks" id="Net-Examples">
                                <MenuItem onSelect={this.exampleNetLoad} eventKey={"loadSmNet"}>Small Net</MenuItem>
                                <MenuItem onSelect={this.exampleNetLoad} eventKey={"loadMedNet"}>Medium Net</MenuItem>
                                <MenuItem onSelect={this.exampleNetLoad} eventKey={"loadMultiNet"}>Multi-Layer Net</MenuItem>
                                </NavDropdown>
                                <MenuItem divider/>
                                <MenuItem onSelect={this.props.newNetwork} eventKey={1.3}>New Network</MenuItem>
                                <MenuItem onSelect={this.props.showNetLoadModal}
                                          eventKey={1.4}>Load Network</MenuItem>

                                    <MenuItem onSelect={this.props.showNetExportModal} eventKey={1.5}>Export
                                    Network</MenuItem>
                                <MenuItem divider/>
                                <MenuItem eventKey={1.6} onSelect={this.props.showLoadDemandModal}>Load Demands</MenuItem>
                                <MenuItem eventKey={1.65} onSelect={this.props.clearDemands}>Clear Demands</MenuItem>
                                <MenuItem divider/>
                                <MenuItem eventKey={1.7} onSelect={this.props.showIPAddressModal}>IP/MAC
                                    Addresses</MenuItem>
                                <MenuItem eventKey={1.8} onSelect={this.props.showPortNumberModal}>Port Numbers</MenuItem>
                                <MenuItem eventKey={1.9} onSelect={this.props.showDistanceWeightsModal}>Distance Based
                                    Weights</MenuItem>
                                <MenuItem eventKey={1.10} onSelect={this.props.showRandomCapsModal}>Randomize
                                    Capacities</MenuItem>
                            </NavDropdown>
                            <NavDropdown eventKey={2} title="Path"
                                         id="Path-dropdown">
                                <MenuItem eventKey={2.1} onSelect={this.props.dispatchPathInfo.bind(this,true)}>Path Info</MenuItem>
                                <MenuItem divider/>
                                <MenuItem eventKey={2.2} onSelect={this.openPathFile}>Open Path
                                    File</MenuItem>
                                <MenuItem divider/>
                                <MenuItem eventKey={2.3} onSelect={this.props.showLoadPathModal}>Load Paths</MenuItem>
                                <MenuItem divider/>
                                <MenuItem eventKey={2.4} onSelect={this.props.showShortPathModal}>Shortest
                                    Paths</MenuItem>
                                <MenuItem eventKey={2.5} onSelect={this.props.showMinTreeModal}>Minimum Spanning
                                    Tree</MenuItem>
                                <MenuItem eventKey={2.6} onSelect={this.props.showWidePathModal}>Widest
                                    Paths</MenuItem>

                            </NavDropdown>
                            <NavDropdown eventKey={3} title="View"
                                         id="View-dropdown">
                                <li><a><Checkbox checked={this.props.netVisInteract.showDemands}
                                                 onChange={this.props.showDemandChange}>Show Demands</Checkbox></a>
                                </li>

                                <li><a><Checkbox checked={this.props.netVisInteract.capVis.showCap}
                                              onChange={this.props.showCapChange}>Show Link Capacity</Checkbox></a>
                                </li>
                            </NavDropdown>
                            <NavDropdown eventKey={4} title="Mode"
                                         id="Mode-dropdown">
                                <li><a><Radio value="edit" name="editMode"
                                              onChange={this.props.modeChange}
                                              checked={this.props.netVisInteract.mouseMode === "edit"}>Edit</Radio></a>
                                </li>

                                <li><a><Radio value="view" name="editMode"
                                              onChange={this.props.modeChange}
                                              checked={this.props.netVisInteract.mouseMode === "view"}>View</Radio></a>
                                </li>
                            </NavDropdown>
                            <NavDropdown eventKey={5} title="Computations"
                                         id="Comp-dropdown">
                                <MenuItem eventKey={5.1}
                                          onClick={this.props.showComputeServeDialog}>Configure
                                    Compute Server</MenuItem>
                                <MenuItem eventKey={5.5} onSelect={this.props.showKShortestPathsModal}>K-shortest
                                    Paths</MenuItem>
                                <MenuItem divider/>
                                <MenuItem eventKey={5.6} disabled>Future
                                    Computation #1</MenuItem>
                                <MenuItem eventKey={5.7} disabled>Your
                                    computation here...</MenuItem>
                            </NavDropdown>
                            <NavItem eventKey={6} onSelect={this.helpSelect}>Help</NavItem>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
      <ReactGridLayout className="layout" layout={this.state.layout} draggableHandle=".panel-heading"
                       onLayoutChange={this.layoutChangeHandler} cols={12}
                       rowHeight={30} >
          {gridItems}
      </ReactGridLayout>
                <ComputeServeDialog />
                <LoadNetDialog />
                <NodeAddDialog />
                <NodeEditDialog />
                <ExportNetDialog />

                <LinkAddDialog />
                <LinkEditDialog />
                <IPAddressDialog />
                <PortNumberDialog />




                <DistanceWeightsDialog />
                <RandomCapsDialog />
                <MinSpanTreeDialog />
                <ShortestPathDialog />
                <WidestPathDialog />
                <PathLoadDialog />
                <LoadDemandDialog />
                <KShortestPathsDialog />
                <input type="file" id="fileInput" accept=".json" onChange={this.netfileLoad} />
                <input type="file" id="pathFileInput" accept=".json" onChange={this.pathfileLoad} />
            </div>
        );
    }
});



const mapStateToProps = (state) => {
    return {
        net: state.net,
        demands: state.demands,
        paths: state.paths,
        netAction: state.netAction,
        netVisInteract: state.netVisInteract,
        showComputeServeModal: state.uiState.showComputeServeModal,
        showHelp: state.uiState.showHelp,
        showNetInfo: state.uiState.showNetInfo,
        showPathInfo: state.uiState.showPathInfo
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        newNetwork: () => {
            dispatch({type: 'NEW_NET'})
        },
        showDemandChange: () => {
            dispatch({type: 'SHOW_DEMAND_CHANGE'})
        },
        showCapChange: () => {
            dispatch({type: 'SHOW_CAP_CHANGE'})
        },
        showComputeServeDialog: () => {
            dispatch({type: 'SHOW_COMPUTE_SERVE_DIALOG'})
        },
        showNetLoadModal: () => {
            dispatch({type: 'SHOW_NET_LOAD_DIALOG'})
        },
        showNetExportModal: () => {
            dispatch({type: 'SHOW_NET_EXPORT_DIALOG'})
        },
        modeChange(e) {
            dispatch({type: 'MODE_CHANGE', mouseMode: e.currentTarget.value});
        },
        netDrawResize: () => {
            dispatch({type: 'NET_DRAW_RESIZE'});
        },
        nodeLinkDelete: (net, demands, visInteract) => {
            dispatch({type: 'NODE_LINK_DEL', net: net, demands: demands, netVisInteract: visInteract})
        },
        showIPAddressModal: () => {
            dispatch({type: 'SHOW_IP_ADDRESS_DIALOG'})
        },
        showPortNumberModal: () => {
            dispatch({type: 'SHOW_PORT_NUMBER_DIALOG'})
        },
        showDistanceWeightsModal: () => {
            dispatch({type: 'SHOW_DIST_WEIGHT_DIALOG'})
        },
        showRandomCapsModal: () => {
            dispatch({type: 'SHOW_RAND_CAP_DIALOG'})
        },
        netLoad: (net) => {
            dispatch({type: 'LOAD_NET', net: net});
        },
        dispatchHelp: (flag) => {
            dispatch({type: 'SHOW_HELP', flag: flag});
        },
        dispatchNetInfo: (flag) => {
            dispatch({type: 'SHOW_NET_INFO', flag: flag});
        },
        dispatchPathInfo: (flag) => {
            dispatch({type: 'SHOW_PATH_INFO', flag: flag});
        },
        nameDescChange: (name, desc) => {
            dispatch({type: 'NAME_DESC_CHANGE', name: name, desc: desc});
        },
        pathCollectionAdd: (pathObj) => {
            dispatch({type: 'PATH_COLLECTION_ADD', pathObj: pathObj});
        },
        showMinTreeModal: () => {
            dispatch({type: 'SHOW_MIN_TREE_DIALOG'});
        },
        showShortPathModal: () => {
            dispatch({type: 'SHOW_SHORT_PATH_DIALOG'});
        },
        showWidePathModal: () => {
            dispatch({type: 'SHOW_WIDE_PATH_DIALOG'});
        },
        showLoadPathModal: () => {
            dispatch({type: 'SHOW_PATH_LOAD_DIALOG'});
        },
        showLoadDemandModal: () => {
            dispatch({type: 'SHOW_DEMAND_LOAD_DIALOG'});
        },
        clearDemands: () => {
            dispatch({type:'DEMANDS_CLEAR'});
        },
        showKShortestPathsModal: () => {
            dispatch({type: 'SHOW_KSHORT_PATHS_DIALOG'});
        },
    };
};

export const AppContainer = connect(
    mapStateToProps,
    mapDispatchToProps)(App)


/**
 *  Deletes selected nodes and links. Handles the issue of deleting all
 *  links attached to a deleted node. Currently handles some tricky stuff
 *  since links refer to nodes by their order in the nodes array.
 *
 *  @method deleteSelectedNodesLinks
 */
function deleteSelectedNodesLinks(net, demands, netVisInteract) {
    let delLinks = [];
    let delNodes = [];
    let delDemands = [];
    let links = net.links;
    let nodes = net.nodes
    let selLinks = netVisInteract.selectedLinks;
    let selNodes = netVisInteract.selectedNodes;
    let demandList = demands.demandList;
    // Add all the links to be deleted to the delete link array
    for (let slink of selLinks) {
        delLinks.push(links.find(d => d.source === slink[0] && d.target === slink[1]));
    }
    for (let snode of selNodes) {
        delNodes.push(nodes.find(d => d.id === snode));
    }
    // Clear the selected nodes and links by updating n
    let newNetVisInteract = Object.assign({}, netVisInteract, {
        selectedNodes: [],
        selectedLinks: []
    });
    // Add all the links connected to nodes to be deleted to the delete link array
    for (let node of delNodes) {
        for (let link of links) {
            if (link.source === node.id || link.target === node.id) {
                delLinks.push(link);
            }
        }
        for (let demand of demandList) {
            if (demand.source === node.id || demand.target === node.id) {
                delDemands.push(demand);
            }
        }
    }
    let newLinks = links.filter((l)=> !delLinks.includes(l));
    let newDemandList = demandList.filter((d) => !delDemands.includes(d));
    let newDemands = Object.assign({}, demands, {demandList: newDemandList});
    let newNodes = nodes.filter((n) => !delNodes.includes(n));
    let newNet = Object.assign({}, net, {nodes: newNodes, links: newLinks});
    return [newNet, newDemands, newNetVisInteract]
}







// WEBPACK FOOTER //
// ./src/App.js